import { IconBase, IconComponent } from './BaseIcon';

export const Undo: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M22 9.32H5.5l4.63-4.62-2.01-2.02-8.13 8.07 8.13 8.11 2.01-2.01-4.73-4.67H22a7.14 7.14 0 1 1 0 14.28h-5.71v2.86h5.7a10 10 0 1 0 0-20Z" />
  </IconBase>
);
